import React from "react"
import clsx from "clsx"
import { useHistory } from "react-router-dom"
import { stringify } from "query-string"
import { useTranslation } from "react-i18next"

import { languageSuffixMap } from "constant"
import classes from "./KflSubCategoryCard.module.scss"

const KflSubCategoryCard = (props) => {
  const {
    subCategory,
    selectedCategory,
    selectedSubCategory,
    setSelectedSubCategory
  } = props

  const history = useHistory()

  const i18n = useTranslation()[1]

  const handleClick = () => {
    if (subCategory._id === selectedSubCategory?._id) return

    setSelectedSubCategory(subCategory)

    const newQueries = {
      categoryId: selectedCategory._id,
      subCategoryId: subCategory._id
    }

    history.push(`/kiosk-foods?${stringify(newQueries)}`)
  }

  const subCategoryName =
    subCategory[`name${languageSuffixMap[i18n.language]}`]

  return (
    <button
      className={clsx(
        classes["button"],
        selectedSubCategory?._id === subCategory._id && classes["active"]
      )}
      onClick={handleClick}
    >
      {subCategoryName}
    </button>
  )
}

export default KflSubCategoryCard